import React from "react";
import { Search } from "lucide-react";
import {
    maintenanceCard,
    maintenanceCardPadding,
    maintenanceHeading,
    maintenanceSectionTitle,
} from "./maintenanceTheme";

/**
 * Filter / search card shell — matches ReportFilterPanel section styling.
 */
const MaintenanceFilterPanel = ({ title = "Search & filters", children, footer }) => (
    <div className={`${maintenanceCard} overflow-hidden`}>
        <div className={maintenanceSectionTitle}>
            <Search className="h-4 w-4 text-blue-600 dark:text-blue-400" />
            <span className={`text-sm font-semibold ${maintenanceHeading}`}>{title}</span>
        </div>
        <div className={`${maintenanceCardPadding} space-y-4`}>{children}</div>
        {footer ? (
            <div className="border-t border-gray-100 dark:border-gray-800 px-4 sm:px-5 py-3">
                {footer}
            </div>
        ) : null}
    </div>
);

export default MaintenanceFilterPanel;
